function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}><path d="M3 14C.719 14 2 8 4 8 3 8 4 3 6 3c0-2 2-3 4-3 8.448 0 5.477 2.114 14 3v16c-7.529 2.258-15 7.919-15 13-1.656 0-6-2 0-12H3c-3 0-2-6 0-6m23 5V3h-2V2h4c1.1 0 2 1.35 2 3v12c0 1.65-.9 3-2 3h-4v-1h2" /></svg>;
});